/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import * as consts from '../../../const';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from 'tc-client-common';

class ConfirmationArchiveExportModal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div id="reports-modal">
          <div id="reports-modal-body">
            <p>{consts.CONFIRM_EXPORT_MODAL_BODY}</p>
          </div>
          <div id="reports-modal-footer">
            <hr className="reports-modal-divider" />
            <Button
              id="export-raports-popup"
              theme="active large-button"
              handleClick={this.props.close}
              label={consts.OK}
            />
          </div>
        </div>
      </div>
    );
  }
}

ConfirmationArchiveExportModal.propTypes = {
  close: PropTypes.func
};

export default ConfirmationArchiveExportModal;
